import React from 'react';
import { Routes, Route, Link, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box, AppBar, Toolbar, Typography, Container, Button } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useAuth } from './contexts/AuthContext';
import GpxUploader from './components/GpxUploader';
import MapView from './components/MapView';
import Login from './components/Login/Login';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#f50057',
    },
  },
});

const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
  const { isAuthenticated, logout } = useAuth();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterMoment}>
        {isAuthenticated && (
          <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static">
              <Toolbar>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                  Valhalla Map Matching
                </Typography>
                <Button color="inherit" component={Link} to="/">
                  Subir GPX
                </Button>
                <Button color="inherit" component={Link} to="/search">
                  Buscar Vehículos
                </Button>
                <Button color="inherit" onClick={logout}>
                  Cerrar Sesión
                </Button>
              </Toolbar>
            </AppBar>
            <Container maxWidth="lg" sx={{ mt: 4 }}>
              <Routes>
                <Route path="/" element={
                  <PrivateRoute>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
                      <GpxUploader />
                    </Box>
                  </PrivateRoute>
                } />
                <Route path="/view/:id" element={
                  <PrivateRoute>
                    <MapView />
                  </PrivateRoute>
                } />
                <Route path="/search" element={
                  <PrivateRoute>
                    <MapView />
                  </PrivateRoute>
                } />
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </Container>
          </Box>
        )}
        {!isAuthenticated && (
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        )}
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
